/**
 * @generated SignedSource<<e77408dadc17e30649907d6e7505824c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vppAssetId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VppAssetDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteVppAssetTPayload",
        "kind": "LinkedField",
        "name": "deleteVppAssetTByVppAssetId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "VppAssetT",
            "kind": "LinkedField",
            "name": "vppAssetT",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VppAssetDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteVppAssetTPayload",
        "kind": "LinkedField",
        "name": "deleteVppAssetTByVppAssetId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "VppAssetT",
            "kind": "LinkedField",
            "name": "vppAssetT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d032f288dc04a09e4fe293f98943ed7b",
    "id": null,
    "metadata": {},
    "name": "VppAssetDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation VppAssetDeleteMutation(\n  $input: DeleteVppAssetTByVppAssetIdInput!\n) {\n  deleteVppAssetTByVppAssetId(input: $input) {\n    vppAssetT {\n      vppAssetId\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "e096f1696c97b0d0634dbdf56569a799";

module.exports = node;
